import React from "react";

import { Link } from "gatsby-plugin-intl";

import Image from "../molecules/image";

import Section from "../organisms/section";
const helpers = require("../../helpers");

import "../../scss/molecules/_jobs-teaser.scss";

class JobsTeaser extends React.Component {
  render() {
    return (
      <Section
        className="pb-0 jobs-teaser section-border-bottom"
        isFluid={true}
      >
        <div className="row">
          <div className="col-md-7 mr-auto">
            <Image
              fluid={this.props.image}
              alt="Office supplies during a Blastic workshop"
              overlay="gradient"
              negateLeft={true}
              negateTop={true}
              aspectRatio={"2x1"}
            >
              <p className="image-overlap">
                Interested in
                <br /> working
                <br /> with
                <br /> us?
              </p>
            </Image>
          </div>
          <div className="col-md-4 d-flex">
            <div className="mx-auto my-auto mx-md-0 py-4">
              <p className="h4 mb-4">Jobs</p>
              <p>
                Interested in working with us?
                <br />
                Find all our vacancies{" "}
                <Link to={helpers.getTrailedUrl("/jobs")}>here</Link>.
              </p>
            </div>
          </div>
        </div>
      </Section>
    );
  }
}

export default JobsTeaser;
